module.exports = {
          srcSet: __webpack_public_path__ + "public/455f4efb828559dc8a83da7d0b572395-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/455f4efb828559dc8a83da7d0b572395-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/455f4efb828559dc8a83da7d0b572395-80.png",
          toString:function(){return __webpack_public_path__ + "public/455f4efb828559dc8a83da7d0b572395-80.png"},
          
          width: 80,
          height: 80
        }